import React from 'react';
import {Col, Container, Row, Card, CardBody, ButtonToolbar, Button} from 'reactstrap';
import {connect} from 'react-redux';
import ReactQueryParams from 'react-query-params';
import {withRouter} from 'react-router-dom';
import Collapse from '../../../components/Collapse';
import * as TextManager from "../../../modules/languages/TextManager";
import Select from '../../../components/Select';
import LoadingProgress from '../../../components/LoadingProgress';
import * as http from "../../../modules/http";
import {fetchPrizeDataIfNeeded, prize_stores_day_manager_update} from '../../../redux/actions/PrizeActions';


export class AddStores extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: '',
            showConfigStore: false,
            sundayStores: ''
        };
    }

    componentDidMount() {
        //this.props.dispatch(fetchStoresByDay());
    }

    changeStoresView = (e, day) => {
        let tmp = '';

        for(let indx in e) {
            if(indx === '0') {
                tmp = String(e[indx].value)
            }
            else {
                tmp += ',' + e[indx].value
            }
        }
        this.props.dispatch(prize_stores_day_manager_update(this.props.manager, day, tmp));
    };

    /*save = () => {
        http.postToServer(
            'prize/stores_day_save',
            this.props.storesDay,
            (response) => {

                this.setState({saving: false, error: false});
                this.props.dispatch(fetchPrizeDataIfNeeded(this.queryParams,true));
                this.props.onClose();

            },
            (response) => {
                console.warn('error storing', response);
                this.setState({saving: false, error: true})

            }
        );
    };*/

    save = () => {
        let data = this.props.storesDayManager.find(e => e.managerId === this.props.manager).dayStores;

        let managerData = {
            managerId: this.props.manager,
            managerName: this.props.managerName,
            dayStores: data
        };

        http.postToServer(
            'prize/stores_day_manager_save',
            managerData,
            (response) => {

                this.setState({saving: false, error: false});
                this.props.dispatch(fetchPrizeDataIfNeeded(this.queryParams,true));
                this.props.onClose();

            },
            (response) => {
                console.warn('error storing', response);
                this.setState({saving: false, error: true})

            }
        );
    };

    render() {

        let isloading = this.props.storesDayManager === undefined;

        let data = [];
        let stores = [];

        //console.log(this.props.storesDayManager)

        if(!isloading) {
            data = this.props.storesDayManager.find(e => e.managerId === this.props.manager).dayStores;
        }

        if(this.props.utilsData && this.props.utilsData.data && this.props.utilsData.data.stores &&
            this.props.utilsData.data.managers) {

            let manager = this.props.utilsData.data.managers.find(e => e.id === this.props.manager);

            if(manager !== undefined) {
                if(manager.storesView !== "" && manager.storesView !== undefined) {
                    stores = this.props.utilsData.data.stores.filter(e => manager.storesView.includes(e.value.toString())) ;
                }
                else {
                    stores = this.props.utilsData.data.stores;
                }
            }
        }

        //console.log(stores);

        return (

            <Row style={{flexDirection: "row-reverse"}}>
                {isloading && <Col md={4}>
                    <LoadingProgress/>
                </Col>}
                {!isloading && <Col md={4} lg={4}>
                    <Card>
                        <CardBody>
                            <div className="card__title">
                                <h5 className="bold-text">הוספת חנויות</h5>
                                {/*<h5 className="subhead">Use default collapse with class <span
                                    className="red-text">shadow</span></h5>*/}
                            </div>
                            <Collapse title="יום ראשון" className="with-shadow">
                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Settings.store}</label>
                                    <div className='form__form-group-field'>
                                        <Select value={data[0].storesDay}
                                                onChange={(e) => this.changeStoresView(e, 1)}
                                                select
                                                delimiter={','}
                                                multi={true}
                                                options={stores}>
                                        </Select>
                                    </div>
                                </div>
                            </Collapse>
                            <Collapse title="יום שני" className="with-shadow">
                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Settings.store}</label>
                                    <div className='form__form-group-field'>
                                        <Select value={data[1].storesDay}
                                                onChange={(e) => this.changeStoresView(e, 2)}
                                                select
                                                delimiter={','}
                                                multi={true}
                                                options={stores}>
                                        </Select>
                                    </div>
                                </div>
                            </Collapse>
                            <Collapse title="יום שלישי" className="with-shadow">
                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Settings.store}</label>
                                    <div className='form__form-group-field'>
                                        <Select value={data[2].storesDay}
                                                onChange={(e) => this.changeStoresView(e, 3)}
                                                select
                                                delimiter={','}
                                                multi={true}
                                                options={stores}>
                                        </Select>
                                    </div>
                                </div>
                            </Collapse>
                            <Collapse title="יום רביעי" className="with-shadow">
                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Settings.store}</label>
                                    <div className='form__form-group-field'>
                                        <Select value={data[3].storesDay}
                                                onChange={(e) => this.changeStoresView(e, 4)}
                                                select
                                                delimiter={','}
                                                multi={true}
                                                options={stores}>
                                        </Select>
                                    </div>
                                </div>
                            </Collapse>
                            <Collapse title="יום חמישי" className="with-shadow">
                                <div className='form__form-group'>
                                    <label
                                        className='form__form-group-label'>{TextManager.getCurrentTextResource().Settings.store}</label>
                                    <div className='form__form-group-field'>
                                        <Select value={data[4].storesDay}
                                                onChange={(e) => this.changeStoresView(e, 5)}
                                                select
                                                delimiter={','}
                                                multi={true}
                                                options={stores}>
                                        </Select>
                                    </div>
                                </div>
                            </Collapse>

                            <ButtonToolbar style={{marginTop: '50px', direction: 'rtl'}}>
                                <Button color='primary' size='sm'
                                        onClick={() => this.save()}>{TextManager.getCurrentTextResource().Text.save}</Button>
                                <Button color='primary' size='sm' style={{marginRight: '20px'}}
                                        onClick={() => this.props.onClose()}>{TextManager.getCurrentTextResource().Text.cancel}</Button>
                            </ButtonToolbar>
                        </CardBody>
                    </Card>
                </Col>}
            </Row>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        storesDayManager: state.prize.storesDayManager,
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(AddStores))